import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F4F7FB] flex flex-col items-center justify-center text-center px-4">
      <div className="relative">
        <h1 className="text-8xl sm:text-9xl md:text-[12rem] font-black text-slate-100 select-none pointer-events-none">
          404
        </h1>
      </div>
      <div className="relative z-10 -mt-6 sm:-mt-10">
        <div className="w-16 h-16 flex items-center justify-center bg-slate-100 rounded-full mx-auto mb-6">
          <i className="ri-compass-discover-line text-slate-400 text-3xl" />
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-[#0B1F3A]" style={{ fontFamily: "'Sora', sans-serif" }}>
          Página no encontrada
        </h2>
        <p className="mt-2 text-sm text-slate-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base sm:text-lg text-slate-500 max-w-md mx-auto" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          La página que buscas no existe o ha sido movida. Te invitamos a explorar el contenido de Aviación Insight RD.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#0B1F3A] text-white text-sm font-semibold rounded-xl hover:bg-[#0d2547] transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            <i className="ri-home-line" />
            Volver al inicio
          </Link>
          <Link
            to="/actualidad"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-slate-200 text-[#0B1F3A] text-sm font-semibold rounded-xl hover:bg-white transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            <i className="ri-newspaper-line" />
            Ver noticias
          </Link>
        </div>
      </div>
    </div>
  );
}